import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { XsrfInterceptor } from './xsrf-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: XsrfInterceptor,
    multi: true
  },
];
